import React, { useState } from 'react';

function ReinventTransferModule({ onSubmit }) {
  const [file, setFile] = useState(null);

  const handleSubmit = () => {
    if (!file) return;
    const formData = new FormData();
    formData.append('smilesFile', file);
    onSubmit('Reinvent', formData, 'reinvent/train_and_generate');
  };

  return (
    <div className="flex flex-col h-full">
      <input type="file" onChange={(e) => setFile(e.target.files[0])} className="form-input" />
      <div className="flex justify-center mt-auto pt-4">
        <button onClick={handleSubmit} className="btn-primary">提交任务</button>
      </div>
    </div>
  );
}

export default ReinventTransferModule;

